var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { Dependencies } from '~/core/decorator';
import { HistoryCasesService } from "~/services/business-service/history-cases.service";
var RetireCase = /** @class */ (function (_super) {
    __extends(RetireCase, _super);
    function RetireCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = { endCaseDate: '' };
        _this.loading = { state: false };
        _this.rules = {
            endCaseDate: [{ required: true, message: '请选择结案时间' }],
        };
        return _this;
    }
    RetireCase.prototype.close = function () { this.reset(); };
    RetireCase.prototype.commit = function () {
        var _this = this;
        var form = this.$refs['form'];
        form.validate(function (valid) {
            if (!valid)
                return;
            _this.loading.state = true;
            _this.historyCasesService.recoverCaseToNormal(_this.caseIds, _this.model).subscribe(function (data) {
                _this.$message.success('操作成功！');
                _this.close();
                _this.loading.state = false;
            }, function (_a) {
                var msg = _a.msg;
                _this.loading.state = false;
            });
        });
    };
    RetireCase.prototype.reset = function () {
        var noteForm = this.$refs['form'];
        noteForm.resetFields();
    };
    __decorate([
        Dependencies(HistoryCasesService)
    ], RetireCase.prototype, "historyCasesService", void 0);
    __decorate([
        Emit('close')
    ], RetireCase.prototype, "close", null);
    __decorate([
        Prop({ required: true })
    ], RetireCase.prototype, "caseIds", void 0);
    RetireCase = __decorate([
        Component({
            components: {},
        })
    ], RetireCase);
    return RetireCase;
}(Vue));
export default RetireCase;
